export default rendererMode => {
    return {
        onRedirect: () => console.log('on redirect')
    }
};